<script lang="ts" setup>
import { definePageMeta } from '#imports'
import { usePageByDevice } from '~/composables/common/use-page-by-device'
import Desktop from '~desktop/pages/account/index.vue'
import Mobile from '~mobile/pages/account/index.vue'
definePageMeta({
  middleware: 'authenticated'
})
const { component } = usePageByDevice(Desktop, Mobile)
</script>
<template>
  <div class="account">
    <component :is="component" />
  </div>
</template>
